(() => {
  const isFrench = String(window.Shopify?.locale || document.documentElement.lang || '').toLowerCase().startsWith('fr')
  const copy = isFrench
    ? {
        maximumWidth: 'Largeur maximale', maximumDepth: 'Profondeur maximale', maximumHeight: 'Hauteur maximale',
        inches: 'po', minimum: 'Minimum', maximum: 'Maximum',
        exactValues: 'Valeurs exactes', filter: 'Filtre', orLess: 'ou moins',
        door: ['porte', 'portes'], burner: ['brûleur', 'brûleurs'], oven: ['four', 'fours'],
        rack: ['grille', 'grilles'], basket: ['panier', 'paniers'], pot: ['cuve', 'cuves'],
      }
    : {
        maximumWidth: 'Maximum width', maximumDepth: 'Maximum depth', maximumHeight: 'Maximum height',
        inches: 'inches', minimum: 'Minimum', maximum: 'Maximum',
        exactValues: 'Exact values', filter: 'Filter', orLess: 'or less',
        door: ['door', 'doors'], burner: ['burner', 'burners'], oven: ['oven', 'ovens'],
        rack: ['rack', 'racks'], basket: ['basket', 'baskets'], pot: ['pot', 'pots'],
      }
  const MAX_FILTERS = {
    'filter.p.m.custom.exterior_width': {
      mode: 'maximum',
      minValues: 8,
      label: copy.maximumWidth,
      unit: copy.inches,
    },
    'filter.p.m.custom.exterior_depth': {
      mode: 'maximum',
      minValues: 8,
      label: copy.maximumDepth,
      unit: copy.inches,
    },
    'filter.p.m.custom.exterior_height': {
      mode: 'maximum',
      minValues: 8,
      label: copy.maximumHeight,
      unit: copy.inches,
    },
  }

  const RANGE_FILTERS = {
    'filter.p.m.custom.total_btu': {
      mode: 'range',
      minValues: 2,
      unit: 'BTU',
      groupNumbers: true,
      useValueIndex: true,
    },
    'filter.p.m.custom.burner_btu': {
      mode: 'range',
      minValues: 2,
      unit: 'BTU',
      groupNumbers: true,
      useValueIndex: true,
    },
    'filter.p.m.custom.oven_btu': {
      mode: 'range',
      minValues: 2,
      unit: 'BTU',
      groupNumbers: true,
      useValueIndex: true,
    },
  }

  const CHIP_FILTERS = {
    'filter.p.m.custom.voltage': {
      maxValues: 12,
      unit: 'V',
      hideCounts: true,
    },
    'filter.p.m.custom.door_type': {
      maxValues: 8,
      hideCounts: true,
    },
    'filter.p.m.custom.number_of_doors': {
      maxValues: 12,
      nouns: copy.door,
      hideCounts: true,
    },
    'filter.p.m.custom.number_of_burners': {
      maxValues: 12,
      nouns: copy.burner,
      hideCounts: true,
    },
    'filter.p.m.custom.number_of_ovens': {
      maxValues: 12,
      nouns: copy.oven,
      hideCounts: true,
    },
    'filter.p.m.custom.number_of_racks': {
      maxValues: 12,
      nouns: copy.rack,
      hideCounts: true,
    },
    'filter.p.m.custom.number_of_fry_baskets': {
      maxValues: 12,
      nouns: copy.basket,
      hideCounts: true,
    },
    'filter.p.m.custom.number_of_fry_pots': {
      maxValues: 12,
      nouns: copy.pot,
      hideCounts: true,
    },
  }

  const CHIP_FILTER_LABELS = {
    'door type': CHIP_FILTERS['filter.p.m.custom.door_type'],
    'type de porte': CHIP_FILTERS['filter.p.m.custom.door_type'],
    'number of doors': CHIP_FILTERS['filter.p.m.custom.number_of_doors'],
    'number of burners': CHIP_FILTERS['filter.p.m.custom.number_of_burners'],
    'number of ovens': CHIP_FILTERS['filter.p.m.custom.number_of_ovens'],
    'number of racks': CHIP_FILTERS['filter.p.m.custom.number_of_racks'],
    'number of fry baskets': CHIP_FILTERS['filter.p.m.custom.number_of_fry_baskets'],
    'number of fry pots': CHIP_FILTERS['filter.p.m.custom.number_of_fry_pots'],
    'nombre de portes': CHIP_FILTERS['filter.p.m.custom.number_of_doors'],
    'nombre de brûleurs': CHIP_FILTERS['filter.p.m.custom.number_of_burners'],
    'nombre de fours': CHIP_FILTERS['filter.p.m.custom.number_of_ovens'],
    'nombre de grilles': CHIP_FILTERS['filter.p.m.custom.number_of_racks'],
    'nombre de paniers à friture': CHIP_FILTERS['filter.p.m.custom.number_of_fry_baskets'],
    'nombre de cuves': CHIP_FILTERS['filter.p.m.custom.number_of_fry_pots'],
  }

  const numericValue = (value) => {
    const match = String(value || '').replace(/,/g, '').match(/-?\d+(?:\.\d+)?/)
    return match ? Number(match[0]) : null
  }

  const inferStep = (values) => {
    const differences = values
      .slice(1)
      .map((value, index) => value - values[index])
      .filter((value) => value > 0)

    const smallest = differences.length ? Math.min(...differences) : 1
    if (smallest >= 1) return 1
    if (smallest >= 0.1) return 0.1
    return 0.01
  }

  const formatNumber = (value, step = 1, groupNumbers = false) => {
    const number = Number(value)
    if (!Number.isFinite(number)) return ''

    const maximumFractionDigits = step >= 1 ? 0 : step >= 0.1 ? 1 : 2
    if (groupNumbers) {
      return new Intl.NumberFormat('en-CA', {
        minimumFractionDigits: 0,
        maximumFractionDigits,
      }).format(number)
    }

    if (maximumFractionDigits === 0) return String(Math.round(number))
    return number.toFixed(maximumFractionDigits).replace(/0+$/, '').replace(/\.$/, '')
  }

  const clamp = (value, min, max) => Math.min(Math.max(value, min), max)

  const dispatchFilterChange = (form) => {
    if (form) form.dispatchEvent(new Event('change', { bubbles: true }))
  }

  const refreshAccordionHeight = (widget) => {
    const item = widget.closest('.m-accordion--item')
    const content = widget.querySelector('.m-accordion--item-content')
    if (!item || !content || !item.classList.contains('open')) return

    window.requestAnimationFrame(() => {
      item.style.setProperty('--content-max-height', `${content.scrollHeight}px`)
    })
  }

  const getNativeValues = (widget) => {
    const inputs = Array.from(widget.querySelectorAll('input[type="checkbox"]'))
    const entries = inputs
      .map((input) => ({ input, value: numericValue(input.value) }))
      .filter((entry) => entry.value !== null && (!entry.input.disabled || entry.input.checked))

    const values = [...new Set(entries.map((entry) => entry.value))].sort((a, b) => a - b)
    return { inputs, entries, values }
  }

  const addNumberField = (container, options) => {
    const field = document.createElement('label')
    field.className = 'm-cf-number-field'

    const labelElement = document.createElement('span')
    labelElement.className = 'm-cf-number-field__label'
    labelElement.textContent = options.label

    const input = document.createElement('input')
    input.type = 'text'
    input.inputMode = options.step >= 1 ? 'numeric' : 'decimal'
    input.className = 'form-field form-field--input'
    input.value = formatNumber(options.value, options.step, options.groupNumbers)
    input.dataset.min = String(options.min)
    input.dataset.max = String(options.max)
    input.setAttribute('aria-label', options.ariaLabel)

    const commit = () => options.onCommit(input)
    input.addEventListener('change', commit)
    input.addEventListener('keydown', (event) => {
      if (event.key === 'Enter') {
        event.preventDefault()
        input.blur()
      }
    })
    input.addEventListener('focus', () => input.select())

    field.append(labelElement, input)
    container.appendChild(field)
    return input
  }

  const syncNativeValues = (entries, lower, upper, min, max, form) => {
    const epsilon = 0.000001
    const isFullRange = lower <= min + epsilon && upper >= max - epsilon
    let changed = false

    entries.forEach(({ input, value }) => {
      const inRange = value >= lower - epsilon && value <= upper + epsilon
      const shouldBeChecked = !isFullRange && inRange
      if (!input.disabled && input.checked !== shouldBeChecked) {
        input.checked = shouldBeChecked
        changed = true
      }
    })

    if (changed) dispatchFilterChange(form)
  }

  const updateRangeTrack = (container, lower, upper, min, max) => {
    const span = max - min || 1
    const start = ((lower - min) / span) * 100
    const end = ((upper - min) / span) * 100
    container.style.setProperty('--range-start', `${clamp(start, 0, 100)}%`)
    container.style.setProperty('--range-end', `${clamp(end, 0, 100)}%`)
  }

  const enhanceNumericWidget = (widget, config) => {
    if (widget.dataset.chefstopFilterUxReady === 'true') return

    const content = widget.querySelector('.m-filter--widget-content')
    const list = content?.querySelector('ul.m-facets')
    if (!content || !list) return

    const { entries, values } = getNativeValues(widget)
    if (values.length < config.minValues) return

    const form = widget.closest('form')
    const min = values[0]
    const max = values[values.length - 1]
    const step = inferStep(values)
    const selected = entries.filter(({ input }) => input.checked).map(({ value }) => value)
    const useValueIndex = config.mode === 'range' && config.useValueIndex === true

    let lower = config.mode === 'range' && selected.length ? Math.min(...selected) : min
    let upper = selected.length ? Math.max(...selected) : max
    if (config.mode === 'maximum') lower = min

    const indexForValue = (value) => {
      const exactIndex = values.indexOf(value)
      if (exactIndex >= 0) return exactIndex

      let nearestIndex = 0
      let nearestDistance = Math.abs(values[0] - value)
      values.forEach((candidate, index) => {
        const distance = Math.abs(candidate - value)
        if (distance < nearestDistance) {
          nearestIndex = index
          nearestDistance = distance
        }
      })
      return nearestIndex
    }

    const sliderPosition = (value) => useValueIndex ? indexForValue(value) : value
    const sliderValue = (slider) => {
      if (!useValueIndex) return Number(slider.value)
      const index = clamp(Math.round(Number(slider.value)), 0, values.length - 1)
      return values[index]
    }
    const updateTrack = (container, nextLower, nextUpper) => {
      if (useValueIndex) {
        updateRangeTrack(container, indexForValue(nextLower), indexForValue(nextUpper), 0, values.length - 1)
      } else {
        updateRangeTrack(container, nextLower, nextUpper, min, max)
      }
    }
    const snapLowerInput = (value) => useValueIndex
      ? (values.find((candidate) => candidate >= value) ?? max)
      : value
    const snapUpperInput = (value) => useValueIndex
      ? ([...values].reverse().find((candidate) => candidate <= value) ?? min)
      : value

    const control = document.createElement('div')
    control.className = `m-cf-control m-cf-control--${config.mode}`
    control.dataset.chefstopControl = 'true'

    const heading = document.createElement('div')
    heading.className = 'm-cf-control__heading'
    heading.textContent = config.mode === 'maximum'
      ? config.label || `Maximum ${widget.dataset.filterLabel || 'value'}`
      : widget.dataset.filterLabel || copy.filter

    const unit = document.createElement('span')
    unit.className = 'm-cf-control__unit'
    unit.textContent = config.unit
    heading.appendChild(unit)

    const sliders = document.createElement('div')
    sliders.className = `m-cf-control__sliders m-cf-control__sliders--${config.mode}`

    const fields = document.createElement('div')
    fields.className = 'm-cf-control__fields'

    const makeSlider = (value, ariaLabel, modifier) => {
      const slider = document.createElement('input')
      slider.type = 'range'
      slider.className = `m-cf-control__slider ${modifier || ''}`.trim()
      slider.min = useValueIndex ? '0' : String(min)
      slider.max = useValueIndex ? String(values.length - 1) : String(max)
      slider.step = useValueIndex ? '1' : String(step)
      slider.value = String(sliderPosition(value))
      slider.setAttribute('aria-label', ariaLabel)
      return slider
    }

    let minSlider
    let minInput
    const maxSlider = makeSlider(
      upper,
      `${widget.dataset.filterLabel || copy.filter} maximum`,
      config.mode === 'range' ? 'm-cf-control__slider--max' : ''
    )
    let maxInput

    const updateInputsAndTrack = () => {
      maxSlider.value = String(sliderPosition(upper))
      maxInput.value = formatNumber(upper, step, config.groupNumbers)

      if (config.mode === 'range') {
        minSlider.value = String(sliderPosition(lower))
        minInput.value = formatNumber(lower, step, config.groupNumbers)
        updateTrack(sliders, lower, upper)
      }
    }

    const commitBounds = (nextLower, nextUpper) => {
      lower = clamp(nextLower, min, max)
      upper = clamp(nextUpper, min, max)
      if (config.mode === 'maximum') lower = min
      if (lower > upper) {
        if (config.mode === 'maximum') lower = min
        else lower = upper
      }

      updateInputsAndTrack()
      syncNativeValues(entries, lower, upper, min, max, form)
    }

    if (config.mode === 'range') {
      minSlider = makeSlider(lower, `${widget.dataset.filterLabel || copy.filter} minimum`, 'm-cf-control__slider--min')
      sliders.append(minSlider, maxSlider)

      minInput = addNumberField(fields, {
        label: copy.minimum,
        value: lower,
        min,
        max,
        step,
        groupNumbers: config.groupNumbers,
        ariaLabel: `${widget.dataset.filterLabel || copy.filter} minimum`,
        onCommit: (input) => commitBounds(snapLowerInput(numericValue(input.value) ?? min), upper),
      })
      maxInput = addNumberField(fields, {
        label: copy.maximum,
        value: upper,
        min,
        max,
        step,
        groupNumbers: config.groupNumbers,
        ariaLabel: `${widget.dataset.filterLabel || copy.filter} maximum`,
        onCommit: (input) => commitBounds(lower, snapUpperInput(numericValue(input.value) ?? max)),
      })

      minSlider.addEventListener('input', () => {
        if (Number(minSlider.value) > Number(maxSlider.value)) minSlider.value = maxSlider.value
        const nextLower = sliderValue(minSlider)
        const nextUpper = sliderValue(maxSlider)
        minInput.value = formatNumber(nextLower, step, config.groupNumbers)
        updateTrack(sliders, nextLower, nextUpper)
      })
      minSlider.addEventListener('change', () => commitBounds(sliderValue(minSlider), sliderValue(maxSlider)))
    } else {
      sliders.append(maxSlider)
      maxInput = addNumberField(fields, {
        label: copy.maximum,
        value: upper,
        min,
        max,
        step,
        groupNumbers: false,
        ariaLabel: `${widget.dataset.filterLabel || copy.filter} maximum`,
        onCommit: (input) => commitBounds(min, numericValue(input.value) ?? max),
      })
    }

    maxSlider.addEventListener('input', () => {
      if (config.mode === 'range' && Number(maxSlider.value) < Number(minSlider.value)) maxSlider.value = minSlider.value
      const nextUpper = sliderValue(maxSlider)
      maxInput.value = formatNumber(nextUpper, step, config.groupNumbers)
      if (config.mode === 'range') updateTrack(sliders, sliderValue(minSlider), nextUpper)
    })
    maxSlider.addEventListener('change', () => {
      const nextLower = config.mode === 'range' ? sliderValue(minSlider) : min
      commitBounds(nextLower, sliderValue(maxSlider))
    })

    control.append(heading, sliders, fields)
    content.insertBefore(control, list)

    const exactValues = document.createElement('details')
    exactValues.className = 'm-cf-exact-values'
    exactValues.open = false

    const exactSummary = document.createElement('summary')
    exactSummary.textContent = copy.exactValues
    exactValues.appendChild(exactSummary)
    content.insertBefore(exactValues, list)
    exactValues.appendChild(list)
    exactValues.addEventListener('toggle', () => refreshAccordionHeight(widget))

    widget.dataset.chefstopFilterUxReady = 'true'
    widget.classList.add('m-cf-enhanced')
    if (config.mode === 'range') updateTrack(sliders, lower, upper)
    refreshAccordionHeight(widget)
  }
  const enhanceChipWidget = (widget, config) => {
    if (widget.dataset.chefstopChipUxReady === 'true') return

    const list = widget.querySelector('ul.m-facets')
    if (!list) return

    const items = Array.from(list.querySelectorAll(':scope > li.m-facet--item'))
    if (items.length < 1 || items.length > config.maxValues) return

    list.classList.add('m-cf-chip-list')
    if (config.hideCounts) list.classList.add('m-cf-chip-list--hide-counts')
    items.forEach((item) => {
      const input = item.querySelector('input[type="checkbox"]')
      const label = item.querySelector('.m-facet--label')
      if (!input || !label) return

      const value = label.textContent.trim()
      const number = numericValue(value)
      if (config.nouns && number !== null) {
        label.textContent = `${value} ${number === 1 ? config.nouns[0] : config.nouns[1]}`
      } else if (config.unit && value && !value.toLowerCase().endsWith(config.unit.toLowerCase())) {
        label.textContent = `${value}${config.unit}`
      }

      const syncSelectedClass = () => item.classList.toggle('is-selected', input.checked)
      syncSelectedClass()
      input.addEventListener('change', syncSelectedClass)
    })

    widget.dataset.chefstopChipUxReady = 'true'
    widget.classList.add('m-cf-chip-widget')
    refreshAccordionHeight(widget)
  }

  const initActiveSummaries = () => {
    document.querySelectorAll('[data-chefstop-summary-label]').forEach((label) => {
      const mode = label.dataset.summaryMode
      const name = label.dataset.summaryName || copy.filter
      const unit = isFrench && label.dataset.summaryUnit === 'inches' ? copy.inches : (label.dataset.summaryUnit || '')
      const min = numericValue(label.dataset.summaryMin)
      const max = numericValue(label.dataset.summaryMax)
      if (max === null) return

      if (mode === 'maximum') {
        label.textContent = `${name}: ${formatNumber(max, 0.01, true)} ${unit} ${copy.orLess}`
      } else if (min !== null) {
        label.textContent = `${name}: ${formatNumber(min, 1, true)}\u2013${formatNumber(max, 1, true)} ${unit}`
      }
    })
  }

  const bindSummaryRemoval = () => {
    if (window.chefstopFilterSummaryRemovalBound) return
    window.chefstopFilterSummaryRemovalBound = true

    document.addEventListener('click', (event) => {
      const link = event.target.closest('[data-chefstop-remove-param]')
      if (!link) return

      const paramName = link.dataset.chefstopRemoveParam
      const url = new URL(window.location.href)
      url.searchParams.delete(paramName)

      event.preventDefault()
      event.stopImmediatePropagation()

      const filtersForm = document.querySelector('collection-filters-form')
      if (filtersForm?.renderPage) {
        filtersForm.renderPage(url.searchParams.toString())
      } else {
        window.location.assign(`${url.pathname}${url.search}${url.hash}`)
      }
    }, true)
  }

  const init = () => {
    document
      .querySelectorAll('.facest-filters-section .m-filter--widget[data-filter-param]')
      .forEach((widget) => {
        const paramName = widget.dataset.filterParam
        const numericConfig = MAX_FILTERS[paramName] || RANGE_FILTERS[paramName]
        const labelKey = String(widget.dataset.filterLabel || '').trim().toLowerCase()
        const chipConfig = CHIP_FILTERS[paramName] || CHIP_FILTER_LABELS[labelKey]
        if (numericConfig) enhanceNumericWidget(widget, numericConfig)
        if (chipConfig) enhanceChipWidget(widget, chipConfig)
      })

    initActiveSummaries()
    bindSummaryRemoval()
  }

  document.addEventListener('collection:rerendered', () => window.requestAnimationFrame(init))
  document.addEventListener('DOMContentLoaded', init)
  if (document.readyState !== 'loading') window.requestAnimationFrame(init)
})()
